<template>

    <div class="shadow overflow-hidden">

      <div>

        <dl>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('programmeOwner.programme') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ programmeOwner.programme_name }}
            </dd>
          </div>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('programmeOwner.employee') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ programmeOwner.employee_name }}
            </dd>
          </div>

          <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('programmeOwner.created_by') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ programmeOwner.created_by }}
            </dd>
          </div>

          <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('programmeOwner.updated_by') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ programmeOwner.updated_by }}
            </dd>
          </div>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('programmeOwner.created_at') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ programmeOwner.created_at }}
            </dd>
          </div>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('programmeOwner.updated_at') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ programmeOwner.updated_at }}
            </dd>
          </div>

        </dl>
      </div>

    </div>

    </template>
    <script>
    // /* eslint-disable */
    import { ref, reactive, watchEffect } from 'vue'
    export default {
      name: 'ProgrammeOwnerForm',
      components: {

      },
      props: {
        propClass: {
          type: Object,
          default: () => ({ empty: true })
        }
      },
      data: function () {
        return {
        }
      },
      emits: ['close-modal', 'submit'],
      setup (props, { emit }) {
        const titleStack = ref(['Admin', 'Forms'])
        // const activeTab = ref(0)

        const programmeOwner = reactive({
          id: '',
          programme_id: '',
          employee_id: '',
          created_by: '',
          created_at: ''

        })

        watchEffect(() => {
          const newprogrammeOwner = props.propClass
          Object.assign(programmeOwner, newprogrammeOwner)
        })

        return {
          titleStack,
          programmeOwner
        }
      }
    }
    </script>
